export default "__VITE_ASSET__BoQMpFxJ__"